// extracted by mini-css-extract-plugin
export default {"wrap":"loginForm_wrap__hgDiH","button":"loginForm_button__ClAG1","radio":"loginForm_radio__tbYsa"};